import script from "./IsSocialLogin.vue?vue&type=script&setup=true&lang=jsx"
export * from "./IsSocialLogin.vue?vue&type=script&setup=true&lang=jsx"

import "./IsSocialLogin.vue?vue&type=style&index=0&id=7531460b&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7531460b"]])

export default __exports__